import { useContext, createContext } from 'react';
export var ProstoreContext = createContext(null);
export function useContextStore(storeOrName) {
    var context = useContext(ProstoreContext);
    if (typeof storeOrName === 'string') {
        var store = context[storeOrName];
        if (!store) {
            throw new Error("Store '" + storeOrName + "' is not registered in the context");
        }
        return store;
    }
    return storeOrName;
}
//# sourceMappingURL=ProstoreContext.js.map